import { Component } from "react";
import WorkoutProgressModule from './WorkoutProgressModule';
import { BUTTON_TITLES } from '../global/constants'
import { makeBEM } from "../global/utils";
import Icon from "../atoms/Icon";
import WorkoutController from "../controllers/WorkoutController";
import { GeneralObserver } from "./Observer";

class WorkoutModule extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            controller: new WorkoutController(this.props.data),
            workout: this.props.data,
        }

        this.observer = false;
        this.moduleName = 'workout';
        this.bindFunctions();
    }

    // Bind functions to instance
    bindFunctions() {
        this.reactFn = this.reactFn.bind(this);
    }

    componentDidMount() {
        this.initialSetup();
    }

    componentDidUpdate(prevProps) {
		if ( this.props.data !== prevProps.data ) {
			this.handlePropChange();
		}
	}

	handlePropChange() {
		const ctrl = this.state.controller;
		ctrl.setWorkout(this.props.data);
		this.setState(({
			controller: ctrl,
		}));
	}

	// Setup observer and subscribe to events from controller
    // Fetch data from controller 
    initialSetup() {
        const ctrl = this.state.controller;
        this.observer = new GeneralObserver(this.reactFn);
        ctrl.addObserver(this.observer);

        this.setState({
            controller: ctrl
        });
    }

    // Reacts to controller events
    // Sets controller and workout
    reactFn() {
        const ctrl = this.state.controller;
        const workout = ctrl.getWorkout();

        this.setState({
            controller: ctrl,
            workout: workout
        });
    }

    // Done btn click handler
    // Calls controller's mark done fn
    handleDoneButtonClick() {
        const ctrl = this.state.controller;
        ctrl.markDone();
    }

    // Restart btn click handler
    // Calls controller's restart fn
    handleRestartButtonClick() {
        const ctrl = this.state.controller;
        ctrl.restart();
    }

    render() {
        const ctrl = this.state.controller;
		if ( !ctrl ) {
			return false;
		}

        const workout = ctrl.getWorkout();
        const showMarkDoneBtn = !workout.isComplete() && !workout.updatedToday;
        const showRestartBtn = workout.isComplete() && !workout.updatedToday;
        const restartBtnClass = `btn--icon-and-text ${makeBEM(this.moduleName, 'restart-btn')}`;
        const isSubmitting = this.state.isSubmitting;

        if ( workout ) {
            
            return (
                <div className={ this.moduleName }>
                    <WorkoutProgressModule 
                        progress={workout.progress}
                        animate={workout.animate ? true : false}
                    />
                    <div 
                        className={ makeBEM(this.moduleName, 'routines') }
                    >
                    {
                        Object.keys(workout.routines).map(key => (
                            <div 
                                className={ makeBEM(this.moduleName, 'routine') }
                                key={key}
                            >
                                <h5 className={`h5 ${makeBEM(this.moduleName, 'routine__name')}` }>
                                {
                                    workout.routines[key].exercise ?
                                    workout.routines[key].exercise.title :
                                    ''
                                }
                                </h5>
                                 <span className={`h5 ${makeBEM(this.moduleName, 'routine__reps')}` }>
                                    {
                                        workout.routines[key].calculatedReps
                                    }
                                </span>
                            </div>
                        ))
                    }
                    </div>

                    {
                        showMarkDoneBtn &&
                        <div className="board__form-btn">
                            <button className={ `btn--icon-and-text ${makeBEM(this.moduleName, 'mark-done-btn')}` }
                                onClick={() => {
                                    this.handleDoneButtonClick()
                                }}
                                disabled={isSubmitting}
                            >   
                                <Icon name="check" size="2"/>{ BUTTON_TITLES.today }
                            </button>
                        </div>
                    }
                    {
                        showRestartBtn && 
                        <div className="board__form-btn">
                            <button 
                                className={restartBtnClass}
                                onClick={() => {
                                    this.handleRestartButtonClick()
                                }}
                                disabled={isSubmitting}
                            >
                            <Icon name="restart" size="2"/>{BUTTON_TITLES.restart}</button>
                        </div>
                    }
                </div>
            );
        } else {
            return '';
        }
    }
}

export default WorkoutModule;